//* Libraries imports
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { IconButton } from "@mui/material";
import { Search, Edit, InfoIcon, Trash2Icon } from "lucide-react";

//* Componentes imports
import { Card, CardContent } from "@components/ui/card";
import {
  deleteAppointment,
  fetchAppointments,
} from "../../appointment/appointmentSlice";

//* Types imports
import { RootState } from "@app/store";

type AppointmentsSectionProps = {
  setAppointments: (appointments: any) => void;
};

export const AppointmentsSection = ({
  setAppointments,
}: AppointmentsSectionProps) => {
  const [loadingAppointment, setLoadingAppointment] = useState(true);
  const { id } = useParams();

  const appointments = useSelector(
    (state: RootState) => state.appointment.items
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const getAppointments = async () => {
    setLoadingAppointment(true);
    await dispatch(
      fetchAppointments({ product: id } as Record<string, string>)
    );
    setLoadingAppointment(false);
  };

  const handleDelete = async (id: string) => {
    if (
      window.confirm(
        "Tem certeza que deseja excluir esta configuração de agendamento?"
      )
    ) {
      await dispatch(deleteAppointment(id));
      dispatch(fetchAppointments({ product: id } as Record<string, string>));
    }
  };

  useEffect(() => {
    getAppointments();
  }, []);

  useEffect(() => {
    setAppointments(appointments);
  }, [appointments, setAppointments]);

  return (
    <section className="flex flex-col w-full items-start rounded-xl">
      <Card className="w-full border border-[#D8E0F0] rounded-[14px] bg-[#FCFCFC] hover:border-[#c8d0e0] transition-colors">
        <CardContent className="p-[20px] ">
          <div className="flex w-full h-9 items-center justify-between mb-5">
            <h1 className="text-xl font-bold" id="atividades">
              Agendas ({appointments.length})
            </h1>
          </div>

          <div className="mb-4 flex w-full" style={{ position: "relative" }}>
            <input
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              placeholder="Pesquisar"
              className="p-2 border rounded"
              style={{
                width: "-webkit-fill-available",
                borderRadius: 20,
                paddingLeft: 40,
              }}
            />
            <Search
              style={{
                position: "absolute",
                top: "20%",
                left: 10,
                color: "grey",
              }}
            />
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full ">
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {appointments.filter((item: any) =>
                  item.name.toLowerCase().includes(search.toLowerCase())
                ).length > 0 ? (
                  appointments
                    .filter((item: any) =>
                      item.name.toLowerCase().includes(search.toLowerCase())
                    )
                    .map((appointment: any, idx) => (
                      <React.Fragment key={appointment._id || idx}>
                        <tr>
                          <td style={{ width: 70, margin: 0, padding: 0 }}>
                            <div
                              style={{
                                padding: 10,
                                height: 75,
                                border: "1px solid lightgrey",
                                borderRadius: 10,
                                borderTopRightRadius: 0,
                                borderBottomRightRadius: 0,
                                borderRight: 0,
                                borderLeft: "1px solid lightgrey",
                                borderTopLeftRadius: 10,
                                borderBottomLeftRadius: 10,
                              }}
                            >
                              <div
                                style={{
                                  border: "1px solid lightgrey",
                                  borderRadius: 10,
                                  minWidth: 51,
                                  minHeight: 51,
                                  width: 51,
                                  height: 51,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  style={{
                                    minWidth: 45,
                                    minHeight: 45,
                                    width: 45,
                                    height: 45,
                                    objectFit: "cover",
                                    borderRadius: 10,
                                  }}
                                  src={
                                    appointment.image
                                      ? appointment.image
                                      : "/icon_agenda.png"
                                  }
                                  alt={appointment.name}
                                />
                              </div>
                            </div>
                          </td>
                          <td style={{ minWidth: 200, margin: 0, padding: 0 }}>
                            <div
                              style={{
                                padding: 10,
                                height: 75,
                                border: "1px solid lightgrey",
                                borderRadius: 10,
                                borderTopRightRadius: 0,
                                borderBottomRightRadius: 0,
                                borderRight: 0,
                                borderLeft: 0,
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0,
                              }}
                            >
                              <div>
                                <p
                                  style={{
                                    color: "grey",
                                    fontSize: 14,
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    width: 100,
                                    display: "block",
                                    overflow: "hidden",
                                  }}
                                >
                                  Agenda
                                </p>
                                <p
                                  style={{
                                    color: "black",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    display: "block",
                                    overflow: "hidden",
                                  }}
                                >
                                  <b style={{ fontWeight: "normal" }}>
                                    {appointment.name}
                                  </b>
                                </p>
                              </div>
                            </div>
                          </td>

                          <td style={{ margin: 0, padding: 0 }}>
                            <div
                              className="flex items-center"
                              style={{
                                justifyContent: "flex-end",
                                height: 75,
                                padding: 10,
                                border: "1px solid lightgrey",
                                borderRadius: 10,
                                borderLeft: 0,
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0,
                              }}
                            >
                              <div
                                style={{
                                  marginRight: 5,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  background: "#f2f2f2",
                                  borderRadius: 10,
                                  width: 35,
                                  height: 35,
                                  color: "grey",
                                }}
                              >
                                <IconButton
                                  style={{
                                    borderRadius: 10,
                                    width: 35,
                                    height: 35,
                                    color: "grey",
                                  }}
                                  onClick={() =>
                                    navigate(
                                      `/appointments/edit/${appointment._id}`
                                    )
                                  }
                                >
                                  <Edit />
                                </IconButton>
                              </div>

                              <div
                                style={{
                                  marginRight: 5,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  background: "#f2f2f2",
                                  borderRadius: 10,
                                  width: 35,
                                  height: 35,
                                  color: "grey",
                                }}
                              >
                                <IconButton
                                  style={{
                                    borderRadius: 10,
                                    width: 28,
                                    height: 28,
                                    color: "grey",
                                  }}
                                  size="small"
                                  onClick={() =>
                                    navigate(
                                      `/appointments/edit/${appointment._id}`
                                    )
                                  }
                                >
                                  <InfoIcon />
                                </IconButton>
                              </div>
                              <div
                                style={{
                                  marginRight: 5,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  background: "#f2f2f2",
                                  borderRadius: 10,
                                  width: 35,
                                  height: 35,
                                  color: "grey",
                                }}
                              >
                                <IconButton
                                  style={{
                                    borderRadius: 10,
                                    width: 35,
                                    height: 35,
                                    color: "grey",
                                  }}
                                  onClick={() =>
                                    handleDelete(appointment._id as string)
                                  }
                                >
                                  <Trash2Icon />
                                </IconButton>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr style={{ height: 10 }}></tr>
                      </React.Fragment>
                    ))
                ) : (
                  <tr>
                    <td colSpan={4} className="py-4 px-4 text-center">
                      Nenhuma configuração de agendamento encontrada.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};
